
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export function WhatsAppButton() {
  const phoneNumber = "5511972888920";
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        size="lg"
        className="whatsapp-button rounded-full w-14 h-14 bg-whatsapp hover:bg-whatsapp/90 shadow-lg"
        onClick={() => window.open(whatsappUrl, '_blank')}
      >
        <MessageSquare className="h-6 w-6 text-white" />
      </Button>
    </div>
  );
}
